module.exports = __webpack_public_path__ + "img/img_03.bbdc830a.png";